export default {
  AUDIT: {
    GET_WITH_UUID: "api/bulletin/audit/{uuid}"
  },
  MAILINGLIST: {
    GET_MAILING_LIST: "api/bulletinemail/{uuid}"
  },
  ARGUMENT: {
    GET_ALL: "api/bulletin/argument/",
    SAVE_NEW_ARGUMENT: "api/bulletin/argument/"
  },
  ATTACHMENT: {
    GET_SINGLE_ATTACHMENT: "api/bulletin/attachment/{uuid}"
  },
  DRAFT_BULLETIN: {
    GET_ALL: "api/bulletin/draft/",
    GET_WITH_UUID: "api/bulletin/draft/{uuid}",
    UPDATE_BULLETIN: "api/bulletin/draft/{uuid}",
    SAVE_NEW_BULLETIN: "api/bulletin/draft/",
    DELETE_BULLETIN: "api/bulletin/draft/{uuid}",
    PUBLISH_BULLETIN: "api/bulletin/draft/{uuid}/publish",
    SEND_TO_APPROVE_BULLETIN: "api/bulletin/draft/{uuid}/pending"
  },
  NOTIFY_GROUP: {
    GET_WITH_GROUP_NAME: "api/email-group/{groupName}",
    SAVE_WITH_GROUP_NAME: "api/email-group/{groupName}"
  },
  MAILING:{
    GET_ALL_MAILING_LIST: "api/bulletin/mailing-list/groups",
    CREATE_NEW_MAILING_LIST: "api/bulletin/mailing-list/group/{groupName}",
    GET_MAILING_LIST: "api/bulletin/mailing-list/group/{uuid}",
    DELETE_MAILING_LIST: "api/bulletin/mailing-list/group/{uuid}",
    EXTRACT_MAILING_LIST: "api/bulletin/mailing-list/extract/{uuid}",
    GET_EMAILS_FROM_MAILING_LIST: "api/bulletin/mailing-list/group/{uuid}/list-emails",
    DELETE_EMAIL_FROM_MAILING_LIST: "api/bulletin/mailing-list/email/{emailUuid}/{groupUuid}",
    ADD_EMAILS_TO_MAILING_LIST: "api/bulletin/mailing-list/group/{uuid}/add-emails",
    SEND_BULLETIN_EMAIL: "api/bulletin/mailing-list/group/{groupUuid}/bulletin/{bulletinUuid}",
    GET_MAILING_LIST_BY_EMAIL: "api/bulletin/mailing-list/groups-by-email/{email}"
  },
  PENDING_BULLETIN: {
    GET_ALL: "api/bulletin/pending/",
    GET_WITH_UUID: "api/bulletin/pending/{uuid}",
    UPDATE_BULLETIN: "api/bulletin/pending/{uuid}",
    PUBLISH_BULLETIN: "api/bulletin/pending/{uuid}/publish"
  },
  PUBLISHED_BULLETIN: {
    GET_ALL: "api/bulletin/published/",
    GET_WITH_UUID: "api/bulletin/published/{uuid}",
    UPDATE_BULLETIN: "api/bulletin/published/{uuid}",
    RETIRE_BULLETIN: "api/bulletin/published/{uuid}/retire"
  },
  RETIRED_BULLETIN: {
    GET_ALL: "api/bulletin/retired/",
    UPDATE_BULLETIN: "api/bulletin/retired/{uuid}",
    GET_WITH_UUID: "api/bulletin/retired/{uuid}"
  },
  SCHEDULED_PUBLISH_BULLETIN: {
    GET_ALL: "api/bulletin/scheduled_publish/",
    UPDATE_BULLETIN: "api/bulletin/scheduled_publish/{uuid}",
    GET_WITH_UUID: "api/bulletin/scheduled_publish/{uuid}",
    DELETE_BULLETIN: "api/bulletin/scheduled_publish/{uuid}",
    PUBLISH_BULLETIN: "api/bulletin/scheduled_publish/{uuid}/publish"
  },
  PERMISSION_AND_GROUP_AVAILABLE: {
    GET_ALL: "api/bulletin/permission/"
  },
  GET_ALL_EXTENSIONS_FILE: "api/bulletin/attachment/allowedfiles",

  GET_ALL_EXTENSIONS_AND_DIMENSION_FILE: "api/bulletin/attachment/allowedimages",

  UPLOAD_BULLETIN_THUMBIMAGE: "api/bulletin/draft/image/{uuid}",
  DELETE_BULLETIN_THUMBIMAGE: "api/bulletin/draft/image/delete/{uuid}",

  UPLOAD_PENDING_BULLETIN_THUMBIMAGE: "api/bulletin/pending/image/{uuid}",
  DELETE_PENDING_BULLETIN_THUMBIMAGE: "api/bulletin/pending/image/delete/{uuid}",

  UPLOAD_SCHEDULED_PUBLISH_BULLETIN_THUMBIMAGE: "api/bulletin/scheduled_publish/image/{uuid}",
  DELETE_SCHEDULED_PUBLISH_BULLETIN_THUMBIMAGE: "api/bulletin/scheduled_publish/image/delete/{uuid}",

  UPLOAD_PUBLISHED_BULLETIN_THUMBIMAGE: "api/bulletin/published/image/{uuid}",
  DELETE_PUBLISHED_BULLETIN_THUMBIMAGE: "api/bulletin/published/image/delete/{uuid}",


  DOWNLOAD_BULLETIN_THUMBIMAGE: "api/bulletin/attachment/image/download/{uuid}?uuidImage={uuidImage}"



};
